module.exports = "/lucky-balls/img/regular_game/check_infoBar/check_015.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/check_infoBar/check_015.png
// module id = 1139
// module chunks = 0